import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import ViewIcon from '../../css/images/icon-Table-View.svg';

const ViewButton = ({ basePath = '', record = {}, type, label = 'View' }) => {
    return (
        <Link 
            className="btn-icon x-table-icon" 
            title={label}
            to={`${basePath}/${type}/${record.cell.row.original.id}/overview`}>
            <img src={ViewIcon} alt="View Table Icon"/>
        </Link>
    );
};

ViewButton.propTypes = {
    /**
     * Currently not used
     */
    basePath: PropTypes.string,
    /**
     * The Link to the data repo in which the file is to be found
     */
    type: PropTypes.string,
    /**
     * The record from which the filepath for viewing is extracted. (record.cell.row.original_id)
     */
    record: PropTypes.object,
    /**
     * The label displayed in browser tooltips
     */
    label: PropTypes.string,
};

export default ViewButton;